import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { UserProvider } from "./context/User/useUser";
import { NavBarProvider } from "./context/NavBar/useNavBar";
import { TabsProvider } from "./context/CustomTab/useTabs";
import { LicenseInfo } from '@mui/x-license';
import { SearchProvider } from "./context/Search/SearchContext";


const muiProKey = 'eb4db06f6ea4786ffe6c452af98ddd61Tz0xMzM4NTAsRT0xODIzNjQ0Nzk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI=';
LicenseInfo.setLicenseKey(muiProKey);

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <BrowserRouter basename={baseUrl}>
    <UserProvider>
      <NavBarProvider>
        <TabsProvider>
          <SearchProvider>
            <App />
          </SearchProvider>
        </TabsProvider>
      </NavBarProvider>
    </UserProvider>
  </BrowserRouter>
);
